import { useMutation, useQuery, useQueryClient } from "react-query";
import api from "../../utils/api";
import { useHubSnackBar } from "../useSnackBar";
import { invalidate } from "../../helpers/clientHelper";

const WORK_ORDER_TESTS = "/work-testing";

const getWorkOrderTests = ({ queryKey }) => {
  const [_, id] = queryKey;
  return api.get(`${WORK_ORDER_TESTS}/work/${id}`);
};
export const useGetWorkOrderTests = (workOrderId) => {
  return useQuery([WORK_ORDER_TESTS, workOrderId], getWorkOrderTests, {
    enabled: !!workOrderId,
  });
};

const postCreateWorkOrderTest = (data) => {
  const id = data.id;
  delete data.id;
  return api.post(`${WORK_ORDER_TESTS}/work/${id}`, data);
};
export const usePostCreateWorkOrderTest = () => {
  const { addSnackbarSuccess } = useHubSnackBar();
  const queryClient = useQueryClient();

  return useMutation(postCreateWorkOrderTest, {
    onSuccess: () => {
      invalidate(queryClient, WORK_ORDER_TESTS);
      addSnackbarSuccess({ message: "Successfully Created Work Order Test" });
    },
  });
};

const deleteWorkOrderTest = (id) => api.delete(`${WORK_ORDER_TESTS}/${id}`);
export const useDeleteWorkOrderTest = () => {
  const { addSnackbarSuccess } = useHubSnackBar();
  const queryClient = useQueryClient();

  return useMutation(deleteWorkOrderTest, {
    onSuccess: () => {
      invalidate(queryClient, WORK_ORDER_TESTS);
      addSnackbarSuccess({ message: "Successfully Deleted Test" });
    },
  });
};
